import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import WebPageMenu from './WebPageMenu';
import Utils from './Utils';
import logo from './../homepage/images/logo.jpg';

const TITLEBAR_FADE_IN = 618 / 2;
const CONTENT_FADE_IN = 1618 / 2;
const LOGO_FADE_IN = 2618 / 2;
const WHITE_SHADOW = "0 0 3rem white";

const PageWrapper = styled.div`
    position: absolute;
    font-family: Arial;
    font-size: 1rem;
    overflow: hidden;
    height: 100%;
    margin: 0;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fafafa;
    overflow-y: auto;
`;

const TitleBar = styled.div`
    position: fixed;
    top: 0 rem;
    left: 0;
    right: 0;
    height: 3.5rem;
    border-bottom: 0.15rem solid #bbbbbb;
    background: linear-gradient(to bottom right, #ffffff, #e7e7e7);
    z-index: 100;
    box-shadow: 0.25rem 0.25rem 5rem rgba(0,0,0,15%);
    opacity: 0;
`;

const TitleText = styled.div`
    position: fixed;
    top: 1.45rem;
    left: 2.5rem;
    font-size: 2rem;
    color: #aaaaaa;
    letter-spacing: 0.5rem;
`;

const TitleBlurb = styled.div`
    position: fixed;
    font-family: Courier;
    font-weight: bold;
    top: 0.75rem;
    right: 2.5rem;
    font-size: 1.15rem;
    color: #ffffff;
    letter-spacing: 0.25rem;
    margin-right: 1rem;
    margin-top: 1.5rem;
    text-shadow: 0.25rem 0.25rem 0.5rem #aaaaaa;
`;

const PageContent = styled.div`
    opacity: 0;
    width: 100%;
`;

const PageBody = styled.div`
    margin: 5rem 15% 0;
    background-color: white;
    border-radius: 0.5rem
`;

const LogoBlock = styled.div`
    text-align: center;
    opacity: 0;
`;

const LogoImage = styled.img`
    width: 12rem;
    margin-bottom: 2.5rem;
    box-shadow: ${WHITE_SHADOW}, ${WHITE_SHADOW};
`;

export class WebPage extends Component {

    static propTypes = {
        brand: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        blurb: PropTypes.string.isRequired,
        content: PropTypes.object.isRequired,
        menu: PropTypes.array.isRequired,
        on_menu_select: PropTypes.func.isRequired,
        logo_ref: PropTypes.element.isRequired
    }

    state = {
        titlebar_ref: React.createRef(),
        page_content_ref: React.createRef()
    };

    componentDidMount() {
        const {titlebar_ref, page_content_ref} = this.state;
        const {logo_ref} = this.props;
        Utils.animate(titlebar_ref, TITLEBAR_FADE_IN, 0, 1, (value, is_last) => {
            titlebar_ref.current.style.opacity = value;
            if (is_last) {
                Utils.animate(page_content_ref, CONTENT_FADE_IN, 0, 1, (value, is_last) => {
                    page_content_ref.current.style.opacity = value;
                    if (is_last) {
                        Utils.animate(logo_ref, LOGO_FADE_IN, 0, 1, (value, is_last) => {
                            logo_ref.current.style.opacity = value;
                        });
                    }
                });
            }
        });
        document.title = this.props.brand;
    }

    render() {
        const {titlebar_ref, page_content_ref} = this.state;
        const {title, blurb, content, menu, on_menu_select, logo_ref} = this.props;
        const title_bar = <TitleBar ref={titlebar_ref}>
            <TitleText>{title}</TitleText>
            <TitleBlurb>{blurb}</TitleBlurb>
        </TitleBar>
        return <PageWrapper id={'webmain'}>
            {title_bar}
            <PageContent ref={page_content_ref}>
                <WebPageMenu
                    options={menu}
                    on_menu_select={on_menu_select}/>
                <PageBody>
                    {content}
                </PageBody>
            </PageContent>
            <LogoBlock ref={logo_ref}><LogoImage src={logo}/></LogoBlock>
        </PageWrapper>
    }
}

export default WebPage;
